<app-navbar />
<!-- Fireworks Effect -->
<div *ngIf="showFireworks" class="fireworks-container" (click)="closeFireworks()">
  <div class="firework" *ngFor="let i of [1,2,3,4,5,6,7,8]"></div>
  <div class="winner-message">
    <div class="trophy-icon">🏆</div>
    <h2>Parabéns ao Vencedor!</h2>
    <p *ngIf="rankingUsuarios.length > 0" class="winner-name">{{ rankingUsuarios[0].nome }}</p>
    <p class="winner-stats" *ngIf="rankingUsuarios.length > 0">{{ rankingUsuarios[0].total }} vistorias concluídas!</p>
    <small class="close-hint">Clique para fechar</small>
  </div>
</div>

<div class="container-fluid dashboard-container">
  <div class="period-filter mb-4">
    <div class="filter-content">
      <div class="filter-row">
        <select class="form-select form-select-sm text-dark fw-semibold bg-transparent" [(ngModel)]="periodoSelecionado"
          (ngModelChange)="atualizarDados()">
          <option value="hoje">Hoje</option>
          <option value="semana">Última Semana</option>
          <option value="mes">Último Mês</option>
          <option value="custom">Personalizado</option>
        </select>

        <button class="btn-update" (click)="atualizarDados()">
          <i class="fas fa-sync-alt"></i> Atualizar
        </button>
      </div>

      <div class="custom-period" *ngIf="periodoSelecionado === 'custom'">
        <div class="date-range-container">
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dataInicialInput"
            (ngModelChange)="onDataInicialChange($event)">
          <span class="text-dark fw-medium">até</span>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dataFinalInput"
            (ngModelChange)="onDataFinalChange($event)">
        </div>
      </div>
    </div>
  </div>

  <!-- 🔹 Outros Cards de Métricas (atualizado para novo shape da API) -->
  <div class="metrics-container">
    <div class="metric-card gradient-bg-primary">
      <div class="metric-top">
        <div class="metric-icon"><i class="fas fa-clipboard-list"></i></div>
        <!-- <div class="metric-badge" [attr.aria-label]="getPercent(totalOS || totalCriacoes)">
          {{ getPercent(totalOS || totalCriacoes) }}
        </div> -->
      </div>
      <h6>Total</h6>
      <h3>{{ totalOS || totalCriacoes }}</h3>
      <div class="metric-bar">
        <div class="metric-bar-fill" [style.width.%]="getPercentValue(totalOS || totalCriacoes)"></div>
      </div>
    </div>

    <div class="metric-card gradient-bg-success">
      <div class="metric-top">
        <div class="metric-icon"><i class="fas fa-check-circle"></i></div>
        <div class="metric-badge" [attr.aria-label]="getPercent(osRealizadas || totalRecadastramentos)">
          {{ getPercent(osRealizadas || totalRecadastramentos) }}
        </div>
      </div>
      <h6>Realizadas</h6>
      <h3>{{ osRealizadas || totalRecadastramentos }}</h3>
      <div class="metric-bar">
        <div class="metric-bar-fill" [style.width.%]="getPercentValue(osRealizadas || totalRecadastramentos)"></div>
      </div>
    </div>

    <div class="metric-card gradient-bg-danger">
      <div class="metric-top">
        <div class="metric-icon"><i class="fas fa-times-circle"></i></div>
        <div class="metric-badge" [attr.aria-label]="getPercent(totalNegativas)">
          {{ getPercent(totalNegativas) }}
        </div>
      </div>
      <h6>Negadas</h6>
      <h3>{{ totalNegativas }}</h3>
      <div class="metric-bar">
        <div class="metric-bar-fill" [style.width.%]="getPercentValue(totalNegativas)"></div>
      </div>
    </div>
    <div class="metric-card gradient-bg-warning">
      <div class="metric-top">
        <div class="metric-icon"><i class="fas fa-clock"></i></div>
        <div class="metric-badge" [attr.aria-label]="getPercent(totalPendentes)">
          {{ getPercent(totalPendentes) }}
        </div>
      </div>
      <h6>Pendentes</h6>
      <h3>{{ totalPendentes }}</h3>
      <div class="metric-bar">
        <div class="metric-bar-fill" [style.width.%]="getPercentValue(totalPendentes)"></div>
      </div>
    </div>
  </div>



  <!-- Map Container - Responsive -->
  <div class="map-container">
    <div class="map-header">
      <h5><i class="fas fa-map-marker-alt me-2"></i> Localização dos Colaboradores</h5>
    </div>
    <div id="map"></div>
  </div>

  <!-- Collaborators Performance - Mobile Card View -->
  <div class="table-container">
    <div class="table-header">
      <h5>
        <i class="fas fa-chart-line me-2"></i>
        Desempenho Detalhado de Hoje
      </h5>

      <!-- Opções de itens por página -->
      <div class="pagination-controls">
        <select class="form-select form-select-sm" [(ngModel)]="itensPorPagina"
          (change)="mudarItensPorPagina(itensPorPagina)">
          <option [value]="5">5 por página</option>
          <option [value]="10">10 por página</option>
          <option [value]="20">20 por página</option>
          <option [value]="50">50 por página</option>
        </select>
      </div>
    </div>

    <!-- Mobile Cards View (visible on mobile only) -->
    <div class="collaborator-cards">
      <div class="collaborator-card" *ngFor="let colaborador of colaboradoresPerformanceForPeriod">
        <div class="collaborator-header">
          <img [src]="colaborador.fotoUrl" class="collaborator-photo" alt="{{ colaborador.nome }}"
            (error)="handleImageError($event)">
          <div class="collaborator-info">
            <h6 class="collaborator-name">{{ colaborador.nome }}</h6>
            <p class="collaborator-company">{{ colaborador.nomeDaEmpresa }}</p>
          </div>
        </div>
        <div class="progress-section">
          <div class="progress-row">
            <span class="progress-label">Cadastros:</span>
            <span class="metric-value">{{ colaborador.totalCadastrosCriados || 0 }}</span>
          </div>
          <div class="progress-row">
            <span class="progress-label">Recadastros:</span>
            <span class="metric-value">{{ colaborador.totalCadastrosRecadastrados || 0 }}</span>
          </div>
          <div class="progress-row">
            <span class="progress-label">Pendentes:</span>
            <span class="metric-value">{{ colaborador.totalPendentes || 0 }}</span>
          </div>
          <div class="progress-row">
            <span class="progress-label">Tempo médio:</span>
            <span class="metric-value">{{ formatTimeString(colaborador.tempoMedioConclusao) }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Table View -->
    <table class="collaborator-table">
      <thead>
        <tr>
          <th>Colaborador</th>
          <th>Empresa</th>
          <th>Cadastro</th>
          <th>Recadastramento</th>
          <th>Pendentes</th>
          <th>Tempo Médio</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let colaborador of colaboradoresPerformanceForPeriod">
          <td>
            <a class="collaborator-link d-flex align-items-center" [routerLink]="['/admin/roteiro-colaborador']"
              [queryParams]="{usuarioId: colaborador.usuarioId}">
              <div class="avatar-wrapper">
                <img [src]="colaborador.fotoUrl" class="collaborator-photo-sm" alt="{{ colaborador.nome }}"
                  (error)="handleImageError($event)">
                <span class="status-dot" [ngClass]="{ 'online': colaborador.isOnline, 'offline': !colaborador.isOnline }" title="{{ colaborador.isOnline ? 'Online' : 'Offline' }}"></span>
              </div>
              <div class="collaborator-meta ms-2">
                <div class="collaborator-name">{{ colaborador.nome }}</div>
                <div class="collaborator-company small text-muted">{{ colaborador.nomeDaEmpresa }}</div>
              </div>
            </a>
          </td>
          <td class="text-center">{{ colaborador.nomeDaEmpresa }}</td>
          <td class="text-center">{{ colaborador.totalCadastrosCriados || 0 }}</td>
          <td class="text-center">{{ colaborador.totalCadastrosRecadastrados || 0 }}</td>
          <td class="text-center">{{ colaborador.totalPendentes || 0 }}</td>
          <td class="text-center">{{ formatTimeString(colaborador.tempoMedioConclusao) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Controles de Paginação -->
    <div class="pagination-wrapper" *ngIf="totalPaginas > 1">
      <nav>
        <ul class="pagination pagination-sm">
          <li class="page-item" [class.disabled]="paginaAtual === 1">
            <a class="page-link" (click)="mudarPagina(paginaAtual - 1)">Anterior</a>
          </li>

          <ng-container *ngFor="let pagina of [].constructor(totalPaginas); let i = index">
            <li class="page-item" [class.active]="paginaAtual === i + 1">
              <a class="page-link" (click)="mudarPagina(i + 1)">{{ i + 1 }}</a>
            </li>
          </ng-container>

          <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
            <a class="page-link" (click)="mudarPagina(paginaAtual + 1)">Próxima</a>
          </li>
        </ul>
      </nav>
      <span class="pagination-info">Mostrando {{ (paginaAtual - 1) * itensPorPagina + 1 }} a {{ Math.min(paginaAtual *
        itensPorPagina, totalItems) }} de {{ totalItems }} colaboradores</span>
    </div>
  </div>
  <!-- Ranking de Usuários (card moderno) -->
  <div *ngIf="isSuperAdmin()" class="ranking-card card my-4">
    <div class="card-header d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-3">
        <i class="fas fa-trophy ranking-icon"></i>
        <div>
          <h5 class="mb-0">Ranking de Vistorias</h5>
          <small class="text-muted">Somente Vistorias Concluída</small>
        </div>
      </div>

      <div class="d-flex align-items-center gap-2">
        <select class="form-select form-select-sm ranking-select" [(ngModel)]="periodoRanking"
          (ngModelChange)="loadRanking()">
          <option value="hoje">Hoje</option>
          <option value="semana">Última Semana</option>
          <option value="mes">Último Mês</option>
          <option value="custom">Personalizado</option>
        </select>

        <div *ngIf="periodoRanking === 'custom'" class="d-flex gap-2">
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dataInicialRankingInput">
          <input type="date" class="form-control form-control-sm" [(ngModel)]="dataFinalRankingInput">
        </div>

        <button class="btn btn-primary btn-sm" (click)="loadRanking()" [disabled]="isLoadingRanking">
          <span *ngIf="isLoadingRanking" class="spinner-border spinner-border-sm me-2" role="status"
            aria-hidden="true"></span>
          Atualizar
        </button>
      </div>
    </div>

    <div class="card-body p-0">
      <ul class="ranking-list list-unstyled m-0">
        <li *ngFor="let r of rankingUsuarios; let i = index" class="ranking-item d-flex align-items-center">
          <div class="rank-badge" [ngClass]="{'gold': i === 0, 'silver': i === 1, 'bronze': i === 2}">{{ i + 1 }}</div>
          <img [src]="r.fotoUrl || (defaultUserImage)" alt="{{ r.nome }}" class="ranking-avatar"
            (error)="handleImageError($event)">
          <div class="ranking-info">
            <div class="ranking-name">{{ r.nome }}</div>

          </div>
          <div class="ranking-count">
            <span class="ranking-total-badge" [ngClass]="{ 'gold': i === 0, 'silver': i === 1, 'bronze': i === 2 }">{{
              r.total }}</span>
          </div>
        </li>
      </ul>

      <div *ngIf="!rankingUsuarios || rankingUsuarios.length === 0" class="p-3 text-center text-muted">Nenhum resultado
        encontrado para os filtros selecionados.</div>
    </div>
  </div>

</div>